module.exports = __webpack_public_path__ + "img/duPontAnalysis4.32b60cd5.png";